// PhonicsLt06.js
// Letter Teams L06 包装组件
// 路由：/phonics/lt06
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterData } from './phonics/phonics_data_lt06';

function PhonicsLt06() {
  return <PhonicsLt letterData={letterData} />;
}

export default PhonicsLt06;
